module.exports = __webpack_public_path__ + "static/scale-model-of-renton-washington-f1d4dd8c7b0c8078d1ed110f8b9f8a6e.png";